<h1>Schulungen</h1>
<section class="article">
  <article>
    <div class="text">
      Für alle Anwender der Software video2manual wird die Teilnahme an einer
      Anwenderschulung empfohlen!
    </div>
  </article>
  <article>
    <h2>Inhalte</h2>
    <div class="text">
      <ul class="content">
        <li>Grundlagen der Video-Anleitung</li>
        <li>Vorbereitung und Durchführung</li>
        <li>Kameratechnik / Kameraführung / Bildgestaltung</li>
        <li>Bearbeitung der Video-Anleitung mit video2manual</li>
        <li>Bereitstellung der fertigen Video-Anleitung</li>
      </ul>
    </div>
  </article>
  <article>
    <h2>Durchführung</h2>
    <div class="text">
      <p>
        Die Schulung ist eintägig. In der Regel ist der Schulungszeitraum von
        09:00 bis 17:00 Uhr. Für Inhouse-Schulungen können andere
        Schulungszeiten vereinbart werden.
      </p>
      <p>
        Die Teilnehmerzahl ist auf 4 Teilnehmer begrenzt. Jedem Teilnehmer wird
        für die Schulung ein Laptop zur Verfügung gestellt, auf dem die
        aktuellste Version von video2manual installiert ist und
        Schulungsmaterial vorbereitet zur Verfügung steht.
      </p>
    </div>
  </article>
  <article>
    <h2>Termin vereinbaren</h2>
    <div class="text">
      <a [routerLink]="['/contact']" class="call">Kontaktieren Sie uns!</a>
    </div>
  </article>
</section>
